// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_2LOzk75","tileContainer":"_2sB7wHE","tile":"_1UwqDiS","gameImage":"_yC-i9dc","loader":"_1-JFgYV"};